<script setup lang="ts">
import { onMounted, ref, watch } from 'vue'
import UIKit from '@pocketprep/ui-kit'

const {
    Slider,
    Input: PocketInput,
} = UIKit

const props = withDefaults(defineProps<{
    modelValue: string | number
    maxQuizSize?: number
    minQuizSize?: number
    disabled?: boolean
}>(), {
    maxQuizSize: 2,
    minQuizSize: 1,
    disabled: false,
})

const emit = defineEmits<{
    'update:modelValue': [value: number]
}>()

const questionCountTextInput = ref('15')
const questionCountSliderVal = ref(15)
const errorFields = ref<string[]>([])

const emitSliderValChanged = () => {
    emit('update:modelValue', questionCountSliderVal.value)
    return questionCountSliderVal.value
}

onMounted(() => {
    questionCountTextInput.value = String(props.modelValue)
})

watch(() => props.modelValue, () => {
    questionCountTextInput.value = String(props.modelValue)
})

watch(() => props.maxQuizSize, () => {
    if (props.maxQuizSize < questionCountSliderVal.value) {
        questionCountSliderVal.value = props.maxQuizSize
    } else if (questionCountSliderVal.value === 0) {
        questionCountSliderVal.value = 15
    }
})

watch(questionCountTextInput, (val: string) => {
    const numVal = parseFloat(val)
    if (isNaN(numVal)) {
        return
    } else if (numVal > props.maxQuizSize) {
        questionCountTextInput.value = String(props.maxQuizSize)
    } else if (numVal < props.minQuizSize) {
        questionCountTextInput.value = String(props.minQuizSize)
    } else {
        questionCountSliderVal.value = numVal
    }
    emitSliderValChanged()
})

watch(questionCountSliderVal, (val: number) => {
    questionCountTextInput.value = String(val)
    emitSliderValChanged()
})
</script>

<template>
    <div class="questions-slider">
        <label for="questions-slider" class="questions-slider__left">
            How many questions?
        </label>
        <div class="questions-slider__right">
            <Slider
                :key="maxQuizSize"
                v-model="questionCountSliderVal"
                :max="maxQuizSize"
                :min="minQuizSize"
                :disabled="disabled"
                size="small"
                class="questions-slider__slider"
                input-id="questions-slider"
            />
            <PocketInput
                v-model="questionCountTextInput"
                class="questions-slider__count"
                :disabled="!questionCountSliderVal || disabled"
                :error="errorFields.includes('minQuizSize')"
            />
        </div>
    </div>
</template>

<style lang="scss" scoped>
.questions-slider {
    border: 1px solid $gray-divider;
    background: $white;
    border-radius: 6px;
    padding: 10px 12px 8px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__left {
        font-size: 15px;
        line-height: 20px;
        font-weight: 500;
    }

    &__right {
        display: flex;
        justify-content: space-between;
    }

    &__count {
        width: 53px;
    }

    :deep(.uikit-input__input) {
        height: 31px;
    }

    &__slider {
        margin-right: 24px;
    }
}
</style>
